export const SEEK_STEP_SECONDS = 10;
export const REPEAT_GAP_MS = 500;
export const SCRUB_COMMIT_MS = 350;
export const SEEK_LADDER = [
    { after: 15, step: 120 },
    { after: 8, step: 60 },
    { after: 3, step: 30 },
    { after: 0, step: SEEK_STEP_SECONDS },
];
export function seekStepSeconds(presses) {
    const gear = SEEK_LADDER.find((g) => presses >= g.after);
    return gear ? gear.step : SEEK_STEP_SECONDS;
}
export function idleScrub() {
    return { target: 0, presses: 0, lastPressAt: 0, scrubbing: false };
}
export function clampToBounds(seconds, bounds) {
    const end = Math.max(bounds.start, bounds.end - 1);
    if (!Number.isFinite(seconds))
        return bounds.start;
    return Math.min(Math.max(seconds, bounds.start), end);
}
export function pressScrub(state, press) {
    if (!(press.bounds.end > press.bounds.start))
        return state;
    const continuing = state.scrubbing && press.now - state.lastPressAt <= REPEAT_GAP_MS;
    const presses = continuing ? state.presses : 0;
    const from = state.scrubbing ? state.target : press.currentTime;
    const step = seekStepSeconds(presses) * press.direction;
    return {
        target: clampToBounds(from + step, press.bounds),
        presses: presses + 1,
        lastPressAt: press.now,
        scrubbing: true,
    };
}
export function shouldCommit(state, now) {
    return state.scrubbing && now - state.lastPressAt >= SCRUB_COMMIT_MS;
}
export function formatDelta(seconds) {
    const sign = seconds < 0 ? "-" : "+";
    return `${sign}${formatClock(Math.abs(seconds))}`;
}
export function formatClock(seconds) {
    const total = Math.max(0, Math.floor(Number.isFinite(seconds) ? seconds : 0));
    const h = Math.floor(total / 3600);
    const m = Math.floor((total % 3600) / 60);
    const s = total % 60;
    const mm = h > 0 ? String(m).padStart(2, "0") : String(m);
    return `${h > 0 ? `${h}:` : ""}${mm}:${String(s).padStart(2, "0")}`;
}
